import {defineStore} from 'pinia';

const useKit = defineStore('kit', {
  state: () => {
    return {
      products: [],
      index: 0,
      pickerType: 'INCLUDED',
    };
  },
});

export default useKit;
